import React from 'react';

import { CurrencyCode, LifecycleStatus } from '@ndvr/portfolio-api';

import { formatCurrency } from 'utils';
import { AccountWithAumIncluded } from 'views/portfolio/account-aum-queries';

interface AccountBalanceProps {
    account: AccountWithAumIncluded;
}

export const AccountBalance = ({ account }: AccountBalanceProps) => {
    const hasValue = (account.externallyManaged && account.forecastStartingValue != null) || account.aum != null;
    return (
        <div className="flex flex-col gap-1">
            <span className={` ${account.externallyManaged ? 'italic' : ''}`}>
                {hasValue
                    ? formatCurrency(
                          account.externallyManaged ? account.forecastStartingValue : account.aum || '0',
                          CurrencyCode.USD,
                      )
                    : '-'}
            </span>
            {account.lifecycleStatus === LifecycleStatus.REAL && (
                <span className={`text-xs ${account.tradingSuspendedAt ? 'text-red-600' : 'text-gray-400'}`}>
                    {account.tradingSuspendedAt ? 'Trading Disabled' : 'Trading Enabled'}
                </span>
            )}
        </div>
    );
};
